import { getUrl } from '@/core/utils/string';

export const ERROR_TEXT = 'Error loading results.';
export const EVENT_SECTION_TITLE = 'Top Results';
export const INPUT_PLACEHOLDER_TEXT = 'Search team, artist, or venue';
export const NO_RESULTS_TEXT = 'No results found.';
export const PERFORMER_SECTION_TITLE = 'Performers';
export const SEARCH_URL = getUrl('search?q=', true);
export const VENUE_SECTION_TITLE = 'Venues';
